module.exports = __webpack_public_path__ + "assets/language-squares/fr-59137941bcafbd1c97269f40052a7e41.jpg";